'use client';

import { useAtomValue } from 'jotai';
import { UtilTitleSimpleTextVideo } from '@sapientpro/sapientpro-data-models';
import styles from './VideoTour.module.scss';
import clientDeviceSize, { ScreenSize } from '../../../store/deviceScreenSize';
import Video from '../../../components/Video/Video';

const VideoBlock = ({
  video,
  previewImage,
}: {
  video: UtilTitleSimpleTextVideo['video'];
  previewImage: UtilTitleSimpleTextVideo['previewImage']
}) => {
  const deviceSize = useAtomValue<ScreenSize>(clientDeviceSize);
  const isMobile = (deviceSize <= ScreenSize.TABLET_PORTRAIT);

  const playMode = isMobile ? 'in-view' : 'hover';

  return (
    <Video
      video={{
        title: '',
        clip: video,
        preview: {
          url: previewImage?.url ?? '',
          alternativeText: previewImage?.alternativeText ?? '',
        },
      }}
      videoType='custom'
      playMode={playMode}
      view='default'
      activeIndex={0}
      videoClassName={styles.videoTour__contentVideo}
    />
  );
};

export default VideoBlock;
